import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Row, Col } from 'reactstrap'
import { useTranslation } from 'react-i18next'

import SidebarSelection from './SidebarSelection'
import { getUor } from 'reducers'
import logoVinci from 'images/logo_vinci.svg'
import logoEngie from 'images/logo-engie-blue.svg'
import logoStef from 'images/logo_stef.png'
import SidebarCGU from './sidebarSelection/SidebarCGU'

const Sidebar = ({ setSearchPanelOpen, searchPanelOpen }) => {
  const { t } = useTranslation()
  const uor = useSelector(getUor)

  return (
    <Row>
      <Col className="sidebar">
        <Row>
          <Col className="px-0">
              <a href="https://www.engie.fr/" className="logo">
                <img src={logoEngie} alt={t('sidebar.logoAlt')} className="img-fluid" />
              </a>
          </Col>
        </Row>
        <Row>
          <Col>
            <SidebarSelection
              setSearchPanelOpen={setSearchPanelOpen}
              searchPanelOpen={searchPanelOpen}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <SidebarCGU/>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default Sidebar
